import { t } from 'ember-intl';
import { or } from 'tio-ui/utilities';
import { PhCalendarDots } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import FeedContainer from '../../feed/feed-container.gts';
import ItemDetails from '../../feed/item-details.gts';
import ItemComment from '../../feed/item-comment.gts';
import type { ItemSignature } from '../../feed/feed-container.gts';
import type { DrawerContext } from '../types.ts';

/**
 * Timeline drawer content component
 * Displays application history and activity feed
 */
export interface TimelineDrawerSignature {
  Args: {
    drawer: DrawerContext;
    formattedHistory: ItemSignature[];
  };
}

const TimelineDrawer: TOC<TimelineDrawerSignature> = <template>
  <@drawer.Header>
    <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-200">{{t
        "tuition_assistance.application_approval.timeline"
      }}</h2>
  </@drawer.Header>

  <@drawer.Body>
    <div class="-mt-6 mb-6">
      {{#if @formattedHistory.length}}
        <FeedContainer @feed={{@formattedHistory}} class="p-6 [&_ul]:overflow-visible">
          <:record as |item|>
            <ItemDetails @details={{item.details}} @date={{item.date}} class="min-h-12 !mb-0" />
          </:record>
          <:comment as |item|>
            <ItemComment
              @approverComment={{item.approverComment}}
              @approverName={{or item.approverName "System"}}
            />
          </:comment>
        </FeedContainer>
      {{else}}
        <div class="p-6 text-center">
          <PhCalendarDots @size="48" class="text-gray-300 dark:text-gray-600 mx-auto mb-4" />
          <p class="text-gray-500 dark:text-gray-400">
            {{t "tuition_assistance.application_approval.no_timeline_data"}}
          </p>
        </div>
      {{/if}}
    </div>
  </@drawer.Body>
</template>;

export default TimelineDrawer;
